import * as React from 'react';
import { useMemo } from 'react';
import { MasonryEngine } from '@leagueplatform/masonry-engine';
import { getMasonryDriver } from '@leagueplatform/masonry';
import { useSponsorId } from '@leagueplatform/manulife-web-extensions';

import { Box, HeadingText, StackLayout } from '@leagueplatform/genesis-core';

// Phase 1 drivers
const MasonryDriverV1 = getMasonryDriver({
  rootNodeId: 'homepageWeb$root',
});

// Phase 2 (Version 2) drivers
const MasonryDriverV2Version2TodayActivities = getMasonryDriver({
  rootNodeId: 'homepage$web$todayActivities',
});

const MasonryDriverV2Version2FindSupport = getMasonryDriver({
  rootNodeId: 'homepage$web$findSupport',
});

const MasonryDriverV2Version2CareServices = getMasonryDriver({
  rootNodeId: 'homepage$web$careServices',
});

function RewardsHubEntryMasonry() {
  const sponsorId = useSponsorId();
  const driver = useMemo(
    () =>
      getMasonryDriver({
        rootNodeId: 'homepage$web$rewardHubEntry',
        ...(sponsorId != null && { queryParams: { sponsorId } }),
      }),
    [sponsorId],
  );
  return <MasonryEngine driver={driver} />;
}

function RewardsHubContextualCardMasonry() {
  const sponsorId = useSponsorId();
  const driver = useMemo(
    () =>
      getMasonryDriver({
        rootNodeId: 'rewardsHub$contextualCards$submitClaimWeb',
        ...(sponsorId != null && { queryParams: { sponsorId } }),
      }),
    [sponsorId],
  );
  return <MasonryEngine driver={driver} />;
}

function Home() {
  return (
    <Box css={{ paddingTop: '$two', margin: '$four' }}>
      <Box css={{ marginY: '$four', marginX: '$auto' }}>
        <HeadingText size="lg" level="1" css={{ textAlign: 'center' }}>
          Welcome to Manulife
        </HeadingText>
        <HeadingText
          size="md"
          level="2"
          css={{ textAlign: 'center', marginTop: '$four' }}
        >
          Homepage Phase 2
        </HeadingText>
        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: '2.5fr 1fr',
            gap: '$two',
            marginTop: '$four',
            width: '100%',
          }}
        >
          <Box>
            <MasonryEngine driver={MasonryDriverV2Version2CareServices} />

            <HeadingText
              size="md"
              level="2"
              css={{
                textAlign: 'center',
                marginTop: '$four',
                marginBottom: '$two',
              }}
            >
              Rewards Hub Contextual Card
            </HeadingText>
            <Box>
              <RewardsHubContextualCardMasonry />
            </Box>
          </Box>
          <StackLayout
            css={{ width: '100%' }}
            spacing="$two"
            horizontalAlignment="stretch"
          >
            <RewardsHubEntryMasonry />
            <MasonryEngine driver={MasonryDriverV2Version2TodayActivities} />
            <Box css={{ width: '100%' }}>
              <MasonryEngine driver={MasonryDriverV2Version2FindSupport} />
            </Box>
          </StackLayout>
        </Box>
      </Box>

      <Box
        as="hr"
        css={{
          border: 'none',
          borderTop: '5px solid $onSurfaceBorderDefault',
          marginY: '$four',
          width: '100%',
        }}
      />

      <HeadingText size="lg" level="1" css={{ textAlign: 'center' }}>
        OLD VERSIONS
      </HeadingText>
      <HeadingText
        size="md"
        level="2"
        css={{ textAlign: 'center', marginTop: '$four' }}
      >
        Homepage Phase 1
      </HeadingText>
      <MasonryEngine driver={MasonryDriverV1} />
    </Box>
  );
}

export default Home;
